import React, { createContext, useState } from "react";

interface PaymentContextProps {
  paymentSuccess: boolean;
  setPaymentSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  bookingItem: any;
  setBookingItem: React.Dispatch<React.SetStateAction<any>>;
}

export const PaymentContext = createContext<PaymentContextProps>({
  paymentSuccess: false,
  setPaymentSuccess: () => {},
  bookingItem: null,
  setBookingItem: () => {},
});

export const PaymentProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [bookingItem, setBookingItem] = useState<any>(null);

  return (
    <PaymentContext.Provider value={{ paymentSuccess, setPaymentSuccess, bookingItem, setBookingItem }}>
      {children}
    </PaymentContext.Provider>
  );
};
